var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconoSolicitudExistente = function SvgIconoSolicitudExistente(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.73,
    height: 30,
    viewBox: "0 0 23.73 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icono_ya_tengo_una_solicitud",
    "data-name": "icono ya tengo una solicitud",
    transform: "translate(-1966.278 -224.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_493",
    "data-name": "Trazado 493",
    d: "M1987.429,224.02h-18.572a2.578,2.578,0,0,0-2.579,2.572v24.855a2.578,2.578,0,0,0,2.579,2.572h18.572a2.578,2.578,0,0,0,2.579-2.572V226.592A2.578,2.578,0,0,0,1987.429,224.02Zm1.189,27.428a1.187,1.187,0,0,1-1.189,1.186h-18.572a1.187,1.187,0,0,1-1.189-1.186V226.592a1.187,1.187,0,0,1,1.189-1.186h18.572a1.187,1.187,0,0,1,1.189,1.186Z",
    transform: "translate(0 0)",
    fill: "#7b868c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_494",
    "data-name": "Trazado 494",
    d: "M1987.819,235.258h-12.172a.693.693,0,1,0,0,1.386h12.172a.693.693,0,1,0,0-1.386Z",
    transform: "translate(-3.408 -4.415)",
    fill: "#7b868c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_495",
    "data-name": "Trazado 495",
    d: "M1987.819,240.894h-12.172a.693.693,0,1,0,0,1.386h12.172a.693.693,0,1,0,0-1.386Z",
    transform: "translate(-3.408 -6.63)",
    fill: "#7b868c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_496",
    "data-name": "Trazado 496",
    d: "M1987.09,248.253l-4.1,5.382-1.433-1.191a.695.695,0,1,0-.89,1.067l1.992,1.654a.7.7,0,0,0,.446.16.679.679,0,0,0,.078-.005.7.7,0,0,0,.475-.268l4.536-5.959a.695.695,0,0,0-1.107-.839Z",
    transform: "translate(-5.557 -9.413)",
    fill: "#7b868c"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconoSolicitudExistente, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconoSolicitudExistente.046d1cf4.svg";
export { ForwardRef as ReactComponent };